<div class="resp-tabs-container min-content-height">
  <span class="icon-padding-left">
    <img src="/assets/tfb-acctmgmt/images/checkmarkfilled.svg" class="greenTick" alt="">
  </span>

  <div *ngIf="isEndUser && isApprovalRequired">
    <div class="row serviceTitleSmall">
      {{authoringContentData?.changeService?.serviceTitleTxt}}
        </div>
        <div class="col-10">
            <div class="offset-3 margin-bottom">
                {{authoringContentData?.changeService?.requestLineTxt1}} <span class="color-magenta"> #{{msisdn}} </span>{{authoringContentData?.changeService?.requestLineTxt2}}<span class="color-magenta">{{email}}</span>{{authoringContentData?.changeService?.requestLineTxt3}}
            </div>
            <div class="offset-4 margin-bottom">
                {{authoringContentData?.changeService?.requestLineTxt4}} <span class="color-magenta">#{{orderId}}</span>.
            </div>
        </div>
    </div>

    <div *ngIf="!isEndUser">
        <div class="serviceTitle">
            {{authoringContentData?.changeService?.changeSubmittedTxt}}
        </div>
        <div class="col-10">
            <div class="offset-3 alignCentre margin-bottom">
                {{authoringContentData?.changeService?.transactionConfirmTxt}}<span class="color-magenta">{{msisdn}}</span>{{authoringContentData?.changeService?.transactionConfirmTxt3}}<span class="color-magenta">{{email}}</span> {{authoringContentData?.changeService?.transactionConfirmTxt2}}
                <span class="color-magenta">{{orderId}}</span>.
            </div>
            <div class="row offset-4 margin-bottom">
                {{authoringContentData?.changeService?.viewBillText}}
            </div>
        </div>

    </div>
    <div class="row offset-5">
        <button class="btn btn-primary managelines-button" (click)="goToManageLines()">{{authoringContentData?.changeService?.backToMangelinesTxt}}</button>
    </div>

</div>
